import { AxiosRequestConfig } from 'axios';
import { GetFinesListData, SendFineEmailData, UpdateFineData } from './fines.types';

class FinesRequestConfig {
  getFinesList = (data: GetFinesListData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'owi/getOwisList',
    data
  });

  getFinesFilterData = (): AxiosRequestConfig => ({
    method: 'POST',
    url: 'owi/getOwiFilterData',
    data: {}
  });

  uploadFinesFiles = (files: File[]): AxiosRequestConfig => {
    const data = new FormData();

    files.reverse().forEach(file => {
      data.append('files', file);
    });

    return { method: 'POST', url: 'owi/uploadOwiFile', data };
  };

  getInProgressFinesCount = (userId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'owi/getInProgressOwiCount',
    data: { userId }
  });

  getFineDetails = (id: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'owi/getOwiById',
    data: { id }
  });

  updateFine = (data: UpdateFineData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'owi/updateOwi',
    data
  });

  sendFineEmail = (data: SendFineEmailData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'owi/sendOwiEmail',
    data
  });

  getDriverByVehicleHistory = (fuhrparkId: string, date: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'owi/getDriverByFuhrparkHistory',
    data: {
      fuhrparkId,
      date
    }
  });

  recognizeFine = (fineId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'owi/recognizeOwi ',
    data: {
      id: fineId
    }
  });

  getOwiMailboxAddress = (): AxiosRequestConfig => ({
    method: 'POST',
    url: 'owi/getOwiMailboxAddress',
    data: {}
  });
}

export const finesRequestConfig = new FinesRequestConfig();
